import React from 'react';
import './unavailable.scss'; // 确保有对应的 SCSS 文件

const Unavailable = () => {
  return (
    <>
      <div className='warningContainer'>
        {/* <h1 className="warning_title">Service Not Available</h1> */}
        <h1 className="warning_title">QR is temporarily unavailable</h1>

        <p className="message">Please proceed to counter / call staff for ordering.</p>

      </div>
    </>
  );
};

export default Unavailable;
